import { Component, RendererFactory2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { ModalComponent } from 'src/app/components/modal/modal.component';
import Swal from 'sweetalert2';
import { Category } from '../interface';
import { ServicesService } from '../services.service';

@Component({
  selector: 'app-service-category',
  templateUrl: './service-category.component.html',
  styleUrls: ['./service-category.component.scss']
})
export class ServiceCategoryComponent extends ModalComponent {
  public serviceCategories$ = this.serviceService.serviceCategories$
  private unsubscribe$ = new Subject();
  public isLoading: boolean;
  constructor(
    renderFactory: RendererFactory2,
    private router: Router,
    private route: ActivatedRoute,
    private serviceService: ServicesService,
  ) {
    super(renderFactory);
  }

  close() {
    this.show = false;
    setTimeout(
      () => this.router.navigate(["."], { relativeTo: this.route.parent }),
      100
    );
  }

  onInit(): void {
    this.isLoading = true
    this.serviceService.getServiceCategories().subscribe(vals => {
      this.isLoading = false
    }, err => {
      this.isLoading = false
    })
  }

  public handleDelete(data: Category) {
    Swal.fire({
      title: 'Are you sure?',
      confirmButtonText: 'Yes',
      type: 'warning',
      text: 'you want to delete this category',
      showCancelButton: true,
    }).then((result) => {
      if (result.value) {
        this.isLoading = true
        this.serviceService.deleteServiceCategory(data.id).subscribe(res => {
          this.isLoading = false
          Swal.fire({
            title: 'Category successfully deleted',
            type: 'success',
            timer: 2000
          })
        }, err => {
          this.isLoading = false
          Swal.fire({
            title: "Error",
            text: err.error.message,
            type: "error",
            timer: 2000,
          });

        })
      }
    })
  }

  public handlePublish(data: Category, event: Event) {
    event.preventDefault()
    const publish = data.published ? false : true
    Swal.fire({
      title: 'Are you sure?',
      confirmButtonText: 'Yes',
      type: 'warning',
      text: `you want to ${publish ? 'publish' : 'unpublish'} this category`,
      showCancelButton: true,
    }).then((result) => {
      if (result.value) {
        this.isLoading = true
        this.serviceService.publishServiceCategory(data.id, publish).subscribe(res => {
          this.isLoading = false
          Swal.fire({
            title: `Category successfully ${publish ? 'published' : 'unpublished'}`,
            type: 'success',
            timer: 2000
          })
        }, err => {
          this.isLoading = false
          Swal.fire({
            title: "Error",
            text: err.error.message,
            type: "error",
            timer: 2000,
          });

        })
      }
    })
  }

  onDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
